// extracted by mini-css-extract-plugin
export default {"backgroundContainer":"BlackFade_backgroundContainer__0QPyw","childrenContainer":"BlackFade_childrenContainer__Jc2Pq","container":"BlackFade_container__Fcpgx"};